<template>
    <div>
        <add-item-button
            title="Add Properties"
            size="xs"
            @click="showAddPropertiesModal()"
        />                  
        <add-property-modal modal-id="addPropertiesModal" />
    </div>
</template>

<script>
    import AddPropertyModal from './reservation-details-add-properties-modal.vue';
    import AddItemButton from '../../common/reservation-add-item-button.vue';

    export default {
        components: {
            AddPropertyModal,
            AddItemButton
        },
        provide() {
            return {
                getAvailablePropertiesRequestData: this.params.getAvailablePropertiesRequestData,
            }
        },
        data() {
            return {
                busy: false,
                addPropertiesModalID: 'addPropertiesModal',
            };
        },
        methods: {
            showAddPropertiesModal() {
                this.$bvModal.show(this.addPropertiesModalID);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    //@include media-breakpoint-down(md) {
    //    .property-add-button {
    //        padding: 0.375rem 0.75rem !important;
    //        font-size: 0.875rem !important;
    //        line-height: 1.5 !important;
    //        border-radius: 0.2rem !important;
    //    }
    //
    //
    //}
</style>
